import React, { useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Range } from 'react-range';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCreditCard, faHandHoldingDollar, faLandmark, faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import {
  BankTransferInfo,
  BankTransferInfoItem,
  CompensationForm,
  ErrorMessage,
  FormInputGroup,
  FormInputGroupContainer,
  InfoBoxContainer,
  InfoItem,
  PayByBankTransfer,
  PayByCardContainer,
  PayNowButton,
  PaymentFrequencyHeading,
  PaymentMethodOption,
  PaymentMethodOptions,
  PaymentMethodSection,
  PaymentProofStyled,
  QuoteAmountTable,
  QuoteInfoContainer,
  // RemoveGuaranteeButton,
  WaitingForPaymentInfo,
  WaitingForPaymentQuoteInfo,
  WarningInfo,
} from './WaitingForPaymentStatusV2.styles';
import {
  ServiceActions,
  ServiceCard,
  ServiceDivider,
  ServiceField,
  ServiceHeader,
  ServicePrimaryButton,
  ServiceSliderRow,
  ServiceTitleBlock,
} from './ServiceComponent.styles';
import { BrokerageFieldRow, BrokerageNotice } from './BrokeraggioV2.styles';
// import { guideType } from '../../../constants';
// import { BACKEND_BASE_URL } from '../../../../config';
import UploaderBonifico from '../Uploader/UploaderBonifico';
import warningIcon from '../../../../assets/redesign_icons/warning-icon.svg';
import parseJson from '../../../helpers/parseJSON';
import axe from '../../../../services/axios-client/axiosClient';
import PageLoading from '../../../componentsV2/elements/PageLoading';
import {
  confirmAlert,
  generalAlertError,
  generalAlertSuccess,
} from '../../../utils/alerts';
import {
  updateBrokerage,
  updateBrokerageProfessionale,
  updateBrokerageTravel,
  updateService,
} from '../../../../features/purchases/purchasesActions';
import { compensationPaymentMethod, primaQuoteTypes, safeCapitalizeWords } from '../../../constants';
import { FormInputSelect } from '../../../formInputsV2/FormInputSelect';
import QuoteGenerateLoading from '../../../componentsV2/elements/QuoteGenerateLoading';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../helpers/brokerageHelpers';
import ServiceComponent from './ServiceComponent';
import { calculateExtraServicePrice } from '../../../../utils/helpers';

const schema = yup.object({
  card_number: yup
    .string()
    .required('Il campo è obbligatorio')
    .matches(/^[0-9]+$/, 'Dovrebbe contenere solo numeri')
    .min(16, 'Il campo dovrebbe contenere 16 numeri'),
  card_expiry: yup
    .string()
    .required('Il campo è obbligatorio')
    .matches(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/, 'Il formato non è valido')
    .min(5, 'Deve contenere una scadenza valida nel formato specificato')
    .max(5, 'Deve contenere una scadenza valida nel formato specificato'),
  card_cvv: yup
    .string()
    .required('Il campo è obbligatorio')
    .matches(/^[0-9]+$/, 'Dovrebbe contenere solo numeri')
    .min(3, 'Dovrebbe contenere almeno 3 numeri')
    .max(4, 'Dovrebbe contenere meno di 5 numeri'),
});

const compensationSchema = yup.object({
  entry_type: yup.string().required('Il campo è obbligatorio'),
});

// const translateError = (error) => {
//   const translations = {
//     'Invalid expiry month': 'Mese di scadenza non valido',
//     'Invalid expiry year': 'Anno di scadenza non valido',
//     'Credit card with wrong check-digit': 'Carta di credito con cvv errata',
//     'Not numeric characters in credit card number':
//       'Caratteri non numerici nel numero della carta di credito',
//   };

//   if (translations[error] !== undefined) {
//     return translations[error];
//   }

//   return error;
// };
const STEP = 1;
const MIN = 0;
const ISSUANCE_FEE_THRESHOLD = 20;
const ISSUANCE_FEE_AMOUNT = 10;

function WaitingForPaymentStatusV2({
  insuranceRequest,
  collectQuoteData,
  rc_quotation,
  hideBrokerageAndService = false,
  risk_quotations,
}) {
  const navigate = useNavigate();
  const [quoteData, setQuoteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentAuthorizationUrl, setPaymentAuthorizationUrl] = useState(null);
  const [val, setVal] = useState({ values: [0] });
  const valRef = useRef(null);
  const [service, setService] = useState({ values: [0] });

  const initialService = { values: [60] };

  const serviceRef = useRef(null);
  valRef.current = val;
  serviceRef.current = service;

  // const [brokerageAmount, setBrokerageAmount] = useState(0);

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);
  // UI only: which payment form is open. A quote that already has a bank-transfer
  // proof opens on the bonifico, everything else on the card.
  const [paymentMethod, setPaymentMethod] = useState(
    rc_quotation?.payment_proofs?.length > 0 ? 'bank' : 'card',
  );
  const paymentPanelRef = useRef(null);

  // Open the chosen form and scroll so all of it is on screen (down to its
  // upload box / submit button). A form taller than the window is aligned to
  // its top instead, so its title is never cut off.
  const selectPaymentMethod = (method) => {
    setPaymentMethod(method);
    setTimeout(() => {
      const panel = paymentPanelRef.current;
      if (!panel) {
        return;
      }
      const fitsInWindow = panel.getBoundingClientRect().height + 90 <= window.innerHeight;
      panel.scrollIntoView({ behavior: 'smooth', block: fitsInWindow ? 'end' : 'start' });
    }, 100);
  };
  const [showLoading, setShowLoading] = useState(false);

  const user = parseJson(localStorage.getItem('user'));

  // "Incasso" is only offered to users with compensations, and (as before) not
  // while a bank-transfer proof is still waiting to be validated.
  const canCompensate = user?.compensations === 1
    && rc_quotation.payment_proofs.find((pp) => pp.payment_proof_valid === null) === undefined;

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset: resetCardForm,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    shouldFocusError: true,
  });

  const {
    register: registerCompensation,
    handleSubmit: handleSubmitCompensation,
    watch,
    formState: { errors: compensationErrors, touchedFields },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(compensationSchema),
    shouldFocusError: true,
    defaultValues: {
      entry_type: '',
    },
  });

  const isValid = (name) => {
    if (compensationErrors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }

    return true;
  };

  const formData = watch();

  const sendBrokerageAmount = async (skipCollect = false) => {
    if (rc_quotation.brokerage_amount > 0) {
      generalAlertError('Non puoi piu cambiare il brokeraggio in questo momento!');
      return;
    }

    if (insuranceRequest?.insurance_request_extra_services?.length > 0) {
      generalAlertError('Non puoi aggiungere il brokeraggio se è già stato aggiunto un servizio.');
      return;
    }

    const allowedProducts = [1, 2, 3, 9, 10, 11, 12, 13, 14, 15, 1000, 1001, 1002, 1003, 1004, 1006];

    if (insuranceRequest?.is_offline === 0) {
      if (allowedProducts.includes(rc_quotation.product_id)) {
        if (skipCollect) {
          await updateBrokerage(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerage(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }

      if (rc_quotation.product_id === 4) {
        if (skipCollect) {
          await updateBrokerageProfessionale(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerageProfessionale(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }

      if (rc_quotation.product_id === 8) {
        if (skipCollect) {
          await updateBrokerageTravel(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerageTravel(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }
    }

    if (insuranceRequest?.is_offline === 1) {
      if (rc_quotation.product_id == 4) {
        if (skipCollect) {
          await updateBrokerageProfessionale(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerageProfessionale(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }

      if (rc_quotation.product_id == 8) {
        if (skipCollect) {
          await updateBrokerageTravel(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerageTravel(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }

      if (![4, 8].includes(rc_quotation.product_id)) {
        if (skipCollect) {
          await updateBrokerage(
            rc_quotation.id,
            valRef.current.values[0],
            () => { },
            skipCollect,
          );
        } else {
          await updateBrokerage(
            rc_quotation.id,
            valRef.current.values[0],
            collectQuoteData,
            skipCollect,
          );
        }
      }
    }
  };

  const sendServiceAmount = async (skipCollect = false) => {
    if (serviceRef.current.values[0] < 60) {
      generalAlertError('Valore Servizio Non Puo Essere meno di 60 Euro');
      return;
    }
    if (
      rc_quotation.product_id === 1
      || rc_quotation.product_id === 2
      || rc_quotation.product_id === 3
    ) {
      if (skipCollect) {
        await updateService(
          rc_quotation.id,
          serviceRef.current.values[0],
          () => { },
          skipCollect,
        );
      } else {
        await updateService(
          rc_quotation.id,
          serviceRef.current.values[0],
          collectQuoteData,
          skipCollect,
        );
      }
    }
  };

  const getTotal = () => {
    let rcTotalAmount = 0;
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount
          += rc_quotation.payment_frequency === 1
            ? parseFloat(item.amount)
            : parseFloat(item.amount / rc_quotation.payment_frequency);
      }
    }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices
          += rc_quotation.payment_frequency === 1
            ? parseFloat(guarantee.amount)
            : parseFloat(guarantee.amount / rc_quotation.payment_frequency)
            || 0;
      });
    }

    rcTotalAmount = rc_quotation.payment_frequency === 1
      ? rc_quotation.amount
      : rc_quotation.amount / rc_quotation.payment_frequency;

    return parseFloat(
      rcTotalAmount + primaGuaranteesPrices + risksTotalAmount,
    ).toFixed(2);
  };

  // const setServiceAmountToZero = async (skipCollect = false) => {
  //   if (
  //     rc_quotation.product_id === 1
  //     || rc_quotation.product_id === 2
  //     || rc_quotation.product_id === 3
  //   ) {
  //     if (skipCollect) {
  //       await updateService(rc_quotation.id, 0, () => {}, skipCollect);
  //     } else {
  //       await updateService(rc_quotation.id, 0, collectQuoteData, skipCollect);
  //     }
  //   }
  // };

  const checkBrokerageVal = (skipCollect = true) => new Promise((resolve) => {
    if (rc_quotation.brokerage_amount != valRef.current.values[0]) {
      confirmAlert(
        'Il brokeraggio non è stato aggiornato, vuoi aggiornarlo?',
        async () => {
          await sendBrokerageAmount(skipCollect);
          resolve(true);
        },
        () => resolve(false),
      );
    } else {
      resolve(true);
    }
  });

  const checkServiceVal = (skipCollect = true) => new Promise((resolve) => {
    if (
      (rc_quotation.product_id === 1)
      && rc_quotation.quotation_services.length === 0
      && initialService.values[0] <= serviceRef.current.values[0]
    ) {
      confirmAlert(
        'Il servizio non è stato aggiornato, vuoi aggiornarlo?',
        async () => {
          await sendServiceAmount(skipCollect);
          resolve(true);
        },
        () => resolve(false),
      );
    } else if (
      (rc_quotation.product_id === 1)
      && rc_quotation.quotation_services.length > 0
      && rc_quotation.quotation_services[0].amount_gross
      != serviceRef.current.values[0]
    ) {
      confirmAlert(
        'Il servizio non è stato aggiornato, vuoi aggiornarlo?',
        async () => {
          await sendServiceAmount(skipCollect);
          resolve(true);
        },
        () => resolve(false),
      );
    } else {
      resolve(true);
    }
  });

  const uploadPaymentProf = async (file) => {
    // check if brokerage amount is updated
    if (!(await checkBrokerageVal())) {
      return;
    }

    // check if service amount is updated
    if (!(await checkServiceVal())) {
      return;
    }

    const uploadedFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(uploadedFile);
    reader.onload = () => {
      const fileType = uploadedFile.type;

      axe
        .post(
          `/insurance-request/${insuranceRequest.id}/upload-payment-proof`,
          {
            document: reader.result.replace(`data:${fileType};base64,`, ''),
            file_type: fileType,
          },
        )
        .then(() => {
          navigate('/');
          generalAlertSuccess(
            'Stiamo verificando la prova del pagamento, attendi nostro feedback!',
          );
        });
    };
  };

  const collectQuoteInformation = async () => {
    setLoading(true);

    try {
      const response = await axe.get(
        `/quotations/${rc_quotation.id}/for-payment`,
      );
      if (response.status === 200) {
        setQuoteData(response.data.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const submitData = async (data) => {
    console.log(hideBrokerageAndService);

    // check if brokerage amount is updated
    if (!(await checkBrokerageVal())) {
      return;
    }

    // check if service amount is updated
    if (!(await checkServiceVal())) {
      return;
    }

    setLoading(true);

    try {
      const response = await axe.post(
        `/payments/insurance-request/${insuranceRequest.id}/pay`,
        {
          card: {
            number: data.card_number,
            exp_month: data.card_expiry.split('/')[0],
            exp_year: data.card_expiry.split('/')[1],
            cvv: data.card_cvv,
          },
        },
      );

      const error_message = response?.data?.error || response?.data?.message || 'Errore durante il pagamento';
      if (response.status === 400) {
        generalAlertError(error_message);
        setShowLoading(false);
        // refresh page to update payment status
        setTimeout(() => { navigate(0); }, 3000);
        setLoading(false);
      } else if (response.status === 500) {
        generalAlertError(error_message);
        setShowLoading(false);
        // refresh page to update payment status
        setTimeout(() => { navigate(0); }, 3000);
        setLoading(false);
      } else if (response.status === 200) {
        setPaymentAuthorizationUrl(response.data.data.user_redirect);
        resetCardForm();
        collectQuoteInformation();
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const formatInput = (value) => value.replace(/(\d{2})(\d{0,3})/, '$1/$2');

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace(/\//g, '');
    const formattedValue = formatInput(inputValue);

    e.target.value = formattedValue;

    setValue('card_expiry', formattedValue);
  };

  const goToCustomerScreen = () => {
    if (insuranceRequest?.active_customer_id) {
      navigate(`/clients/${insuranceRequest.active_customer_id}`);
      return;
    }

    if (insuranceRequest?.customer_id) {
      navigate(`/clients-not-active/${insuranceRequest.customer_id}`);
      return;
    }

    generalAlertError('Cliente non trovato per questa richiesta assicurativa.');
  };

  useEffect(() => {
    collectQuoteInformation();
  }, [rc_quotation.id]);

  const payWithCompensation = async (formData) => {
    setShowLoading(true);

    try {
      const shouldProcessPayment = rc_quotation.with_compensation !== 1
        || (rc_quotation.is_compensation_confirmed === 1
          && rc_quotation.amount_paid !== null
          && rc_quotation.amount !== rc_quotation.amount_paid);

      if (!shouldProcessPayment) {
        setShowLoading(false);
        return;
      }

      const compensationValue = rc_quotation.with_compensation === 1 ? 0 : 1;
      const endpoint = rc_quotation.with_compensation !== 1
        ? `/insurance-request/${insuranceRequest.id}/pay-with-compensation/${compensationValue}`
        : `/insurance-request/${insuranceRequest.id}/pay-with-compensation/1`;

      const response = await axe.post(endpoint, formData);

      if (response.status === 200) {
        collectQuoteData();
        generalAlertSuccess('Pratica pagata con pagamento messa a cassa!');
        navigate('/');
      } else {
        const error_message = response?.data?.error || response?.data?.message || 'Errore durante il pagamento';
        generalAlertError(error_message);
        setShowLoading(false);
        // refresh page to update payment status
        setTimeout(() => { navigate(0); }, 3000);
      }
    } catch (error) {
      generalAlertError(error?.response?.data?.message || 'Errore durante il pagamento');
    } finally {
      setShowLoading(false);
    }
  };

  // const payWithCompensationTwoPayments = () => {
  //   confirmAlert('Dopo sei mesi devi pagare la altra rate', () => payWithCompensation());
  // };
  const compensationConfirmAlertHandle = async () => {
    // check if brokerage amount is updated
    if (!(await checkBrokerageVal())) {
      return;
    }

    // check if service amount is updated
    if (!(await checkServiceVal())) {
      return;
    }

    confirmAlert('Sei sicuro di pagare con pagamento messa a cassa?', () => {
      setShowLoading(true);
      payWithCompensation(formData);
    });
    // if (quote.payment_frequency === 2) {
    //   confirmAlert('Sei sicuro di pagare con compensazione?', () => payWithCompensationTwoPayments());
    // } else {
    //   confirmAlert('Sei sicuro di pagare con compensazione?', () => payWithCompensation());
    // }
  };

  // Function to determine if the Extra Service button should be shown
  const shouldShowExtraServiceButton = () => {
    if (rc_quotation.status === 7 || rc_quotation.status === 6) {
      return false;
    }

    if (rc_quotation.payment_frequency === 1 && rc_quotation.payments.length > 0 && rc_quotation.status === 4) {
      return false;
    }

    if (rc_quotation.payment_frequency === 2 && rc_quotation.payments.length === 2 && insuranceRequest.insurance_request_extra_services?.length === 0) {
      return false;
    }

    if (rc_quotation.payment_frequency === 2 && rc_quotation.payments.length >= 1 && insuranceRequest.insurance_request_extra_services?.length != 0 && insuranceRequest.insurance_request_extra_services[0].amount_paid != null) {
      return false;
    }
    return true; // Default: always show
  };

  useEffect(() => {
    if (rc_quotation !== null) {
      setVal({
        values: [rc_quotation.brokerage_amount],
      });
      if (
        rc_quotation.quotation_services
        && rc_quotation.quotation_services.length > 0
      ) {
        setService({
          values: [rc_quotation.quotation_services[0].amount_gross],
        });
      }
    }
  }, [rc_quotation]);

  if (loading) {
    return <PageLoading />;
  }

  // const getTotalAmount = () => {
  //   let rcTotalAmount = 0;
  //   let risksTotalAmount = 0;
  //   let rcBrokeraggio = 0;
  //   let rcServiceAmount = 0;
  //   let primaGuaranteesPrices = 0;
  //   let extraServicePrice = 0;

  //   if (Array.isArray(insuranceRequest.insurance_request_extra_services)) {
  //     insuranceRequest.insurance_request_extra_services.forEach((service) => {
  //       if (!service.amount_paid) {
  //         extraServicePrice += parseFloat(service.total_price);
  //       } else {
  //         extraServicePrice += parseFloat(service.total_price / rc_quotation.payment_frequency);
  //       }
  //     });
  //   }

  //   if (rc_quotation.company_id === 2) {
  //     rc_quotation.guarantees.forEach((guarantee) => {
  //       primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
  //     });
  //   }

  //   rcTotalAmount = rc_quotation.amount;

  //   rcBrokeraggio = rc_quotation.brokerage_amount;
  //   rcServiceAmount = rc_quotation.quotation_services
  //     && rc_quotation.quotation_services.length > 0
  //     ? rc_quotation.quotation_services[0].amount_gross
  //     : 0;

  //   if (risk_quotations && risk_quotations.length > 0) {
  //     for (let i = 0; i < risk_quotations.length; i++) {
  //       const item = risk_quotations[i];

  //       risksTotalAmount += parseFloat(item.amount);
  //     }
  //   }

  //   return parseFloat(
  //     rcTotalAmount
  //     + risksTotalAmount
  //     + rcBrokeraggio
  //     + rcServiceAmount
  //     + primaGuaranteesPrices
  //     + extraServicePrice,
  //   ).toFixed(2);
  // };

  // One bonifico upload creates an RC proof and then one proof per risk quotation, in that order,
  // so a risk proof belongs to the latest RC proof with a lower id.
  const getBonificoPayments = () => {
    const groups = [...(rc_quotation.payment_proofs ?? [])]
      .sort((a, b) => a.id - b.id)
      .map((rcProof) => ({ rcProof, proofs: [rcProof] }));

    (risk_quotations ?? [])
      .flatMap((rq) => rq.payment_proofs ?? [])
      .forEach((riskProof) => {
        const owner = [...groups].reverse().find((g) => g.rcProof.id < riskProof.id) ?? groups[0];
        owner?.proofs.push(riskProof);
      });

    return groups.map(({ rcProof, proofs }) => {
      const states = proofs.map((p) => p.payment_proof_valid);
      let valid = 1;
      if (states.includes(0)) valid = 0;
      else if (states.includes(null)) valid = null;

      return {
        rcProof, // keeps file, file_type and id for the <embed> and the key
        proofs,
        valid,
        amount: proofs.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0),
      };
    });
  };

  const getTotalAmount = () => {
    let rcTotalAmount = 0;
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;
    let servicePrice = 0;

    if (
      insuranceRequest.insurance_request_extra_services?.length > 0
    ) {
      insuranceRequest.insurance_request_extra_services?.forEach((service) => {
        servicePrice += parseFloat(calculateExtraServicePrice(rc_quotation, service));
      });
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];
        risksTotalAmount += rc_quotation.payment_frequency === 1 ? parseFloat(item.amount) : parseFloat(item.amount / rc_quotation.payment_frequency);
      }
    }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += rc_quotation.payment_frequency === 1 ? parseFloat(guarantee.amount) : parseFloat(guarantee.amount / rc_quotation.payment_frequency) || 0;
      });
    }

    rcTotalAmount = rc_quotation.payment_frequency === 1 ? parseFloat(rc_quotation.amount) : parseFloat(rc_quotation.amount / rc_quotation.payment_frequency);

    return parseFloat(
      rcTotalAmount + primaGuaranteesPrices + risksTotalAmount + servicePrice + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation)),
    ).toFixed(2);
  };

  const paymentsMadeWithCard = quoteData.quotation_payments.filter(
    (p) => p.status === 4,
  ).length;
  const paymentsMadeWithBonifico = rc_quotation.payment_proofs.filter(
    (p) => p.payment_proof_valid === 1,
  ).length;
  const paymentsMadeWithCompensation = rc_quotation.product_id === 8
    ? 0
    : rc_quotation.payments.filter((p) => p.payment_type === 'compensation')
      .length;
  const paymentMadeCount = paymentsMadeWithBonifico
    + paymentsMadeWithCard
    + paymentsMadeWithCompensation;

  const totalPaymentsRequired = rc_quotation.payment_frequency ?? 1;

  const get_amount_to_pay = () => {
    let primaGuaranteesPrices = 0;
    const isSecondPayment = rc_quotation.amount_paid !== null;
    const brokerage = rc_quotation.brokerage_amount != 0
      ? (isSecondPayment && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation))
      : 0;
    let extraServicePrice = 0;

    if (
      insuranceRequest.insurance_request_extra_services?.length > 0
    ) {
      insuranceRequest.insurance_request_extra_services?.forEach((service) => {
        extraServicePrice += parseFloat(calculateExtraServicePrice(rc_quotation, service));
      });
    }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    let amount_to_pay = parseFloat(
      quoteData.quotation.amount / quoteData.quotation.payment_frequency
      + brokerage
      + (rc_quotation.quotation_services
        && rc_quotation.quotation_services.length > 0
        ? rc_quotation.quotation_services[0].amount_gross
        : 0),
    );

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        amount_to_pay
          += item.company_id == rc_quotation.company_id
            ? parseFloat(item.amount / rc_quotation.payment_frequency)
            : parseFloat(item.amount / item.payment_frequency);
      }
    }

    return (
      amount_to_pay
      + primaGuaranteesPrices / rc_quotation.payment_frequency
      + extraServicePrice
    ).toFixed(2);
  };

  const getAmountForBrokerage = () => {
    let primaGuaranteesPrices = 0;

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    let amount_to_pay = parseFloat(
      (quoteData.quotation.amount - (quoteData.quotation.issuance_fee || 0))
      / quoteData.quotation.payment_frequency
      + (rc_quotation.quotation_services
        && rc_quotation.quotation_services.length > 0
        ? rc_quotation.quotation_services[0].amount_gross
        : 0),
    );

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        amount_to_pay
          += item.company_id == rc_quotation.company_id
            ? parseFloat(item.amount / rc_quotation.payment_frequency)
            : parseFloat(item.amount / item.payment_frequency);
      }
    }

    return (
      amount_to_pay
      + primaGuaranteesPrices / rc_quotation.payment_frequency
    ).toFixed(2);
  };

  if (showLoading) {
    return <QuoteGenerateLoading message="Elaborazione del pagamento. Attendi..." countNr={80} />;
  }

  const issuanceFeeAmount = rc_quotation?.issuance_fee_override === null
    || rc_quotation?.issuance_fee_override === undefined
    ? ISSUANCE_FEE_AMOUNT
    : Number(rc_quotation.issuance_fee_override);

  const handleAddBrokerageClick = () => {
    if (valRef.current.values[0] >= ISSUANCE_FEE_THRESHOLD) {
      confirmAlert(
        `Hai selezionato € ${valRef.current.values[0]} di brokeraggio. `
        + `Verranno aggiunti €${issuanceFeeAmount} di spese di emissione a carico del cliente: `
        + `la RCA aumenta di €${issuanceFeeAmount}.`,
        () => sendBrokerageAmount(),
        () => { },
        'Spese di emissione',
      );
      return;
    }

    sendBrokerageAmount();
  };

  const bonificoPayments = getBonificoPayments();

  return (
    <>
      <div className="row">
        <div className="col-12 col-xxl-12 mt-0 mb-1 mt-xxl-0">
          {!user.managed_by_broker_id
            && rc_quotation.amount_paid === null
            && (
              <div className="pagament-status-step-four">
                <ServiceCard>
                  <ServiceHeader>
                    <ServiceTitleBlock>
                      <h3>Aggiungi Brokeraggio</h3>
                    </ServiceTitleBlock>
                    <ServiceActions>
                      <ServicePrimaryButton
                        type="button"
                        onClick={rc_quotation.product_id === 1
                          ? () => confirmAlert(
                            'Sei sicuro di voler aggiungere il brokeraggio? Se lo aggiungi, non potrai più aggiungere un servizio.',
                            () => handleAddBrokerageClick(),
                          )
                          : () => handleAddBrokerageClick()}
                      >
                        Aggiungi
                      </ServicePrimaryButton>
                    </ServiceActions>
                  </ServiceHeader>
                  <BrokerageNotice>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    <p>
                      Fai attenzione perché il brokeraggio non può
                      essere modificato dopo che è stato effettuato un
                      pagamento.
                    </p>
                  </BrokerageNotice>
                  <ServiceDivider />
                  <BrokerageFieldRow>
                    <ServiceField>
                      <label htmlFor="payment-brokerage-value">Inserisci Brokeraggio</label>
                      <input
                        id="payment-brokerage-value"
                        type="number"
                        placeholder="Inserisci il brokeraggio"
                        value={val.values}
                        max={
                          (getAmountForBrokerage()
                            * 50)
                          / 100
                        }
                        onChange={(e) => {
                          const maxVal = (getAmountForBrokerage()
                            * 50)
                            / 100;
                          if (e.target.value > maxVal) {
                            setVal({
                              values: [parseInt(maxVal)],
                            });
                          } else {
                            setVal({
                              values: [
                                Math.floor(e.target.value * 100) / 100,
                              ],
                            });
                          }
                        }}
                      />
                    </ServiceField>
                    {val.values[0] >= ISSUANCE_FEE_THRESHOLD && (
                      <BrokerageNotice>
                        <FontAwesomeIcon icon={faTriangleExclamation} />
                        <p>
                          {`Superando i € ${ISSUANCE_FEE_THRESHOLD} di brokeraggio verranno aggiunti € ${issuanceFeeAmount} di spese di emissione a carico del cliente.`}
                        </p>
                      </BrokerageNotice>
                    )}
                  </BrokerageFieldRow>
                  <ServiceSliderRow>
                    <span>&euro; 0.00</span>
                    <div className="slider">
                      <Range
                        values={val.values}
                        step={STEP}
                        min={MIN}
                        max={
                          (getAmountForBrokerage()
                            * 50)
                          / 100
                        }
                        onChange={(values) => {
                          const maxAllowed = (getAmountForBrokerage()
                            * 50)
                            / 100;
                          const amount = values[0] + 0.5;
                          if (maxAllowed < amount) {
                            setVal({
                              values: [
                                Math.floor(maxAllowed * 100) / 100,
                              ],
                            });
                          } else {
                            setVal({
                              values: [Math.floor(values * 100) / 100],
                            });
                          }
                        }}
                        renderTrack={({ props, children }) => (
                          <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            style={{
                              ...props.style,
                              height: '32px',
                              display: 'flex',
                              width: '95%',
                              margin: '0 auto',
                            }}
                          >
                            <div
                              ref={props.ref}
                              style={{
                                height: '8px',
                                width: '100%',
                                borderRadius: '140px',
                                alignSelf: 'center',
                                backgroundColor: '#DFF3EA',
                              }}
                            >
                              {children}
                            </div>
                          </div>
                        )}
                        renderThumb={({ props }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: '24px',
                              width: '24px',
                              borderRadius: '50%',
                              backgroundColor: '#00A651',
                              border: '3px solid #fff',
                              boxShadow: '0 1px 4px rgba(16, 24, 40, 0.25)',
                              outline: 'none',
                            }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                top: '-28px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                whiteSpace: 'nowrap',
                                color: '#00A651',
                                fontFamily: "'Inter', sans-serif",
                                fontSize: '15px',
                                fontWeight: 600,
                                lineHeight: '20px',
                              }}
                            >
                              &euro;
                              {' '}
                              {Math.floor(val.values[0] * 100) / 100}
                            </div>
                          </div>
                        )}
                      />
                    </div>
                    <span>
                      &euro;
                      {' '}
                      {(
                        (getAmountForBrokerage()
                          * 50)
                        / 100
                      ).toFixed(2)}
                    </span>
                  </ServiceSliderRow>
                </ServiceCard>
                {/* {(rc_quotation.product_id === 1
                  || rc_quotation.product_id === 2
                  || rc_quotation.product_id === 3) && (
                  <MarkupContainer className="mt-2">
                    <div className="row">
                      <div className="col-12 col-xxl-8">
                        <MarkupTitle>Aggiungi Servizio</MarkupTitle>
                        <DefaultInfo>
                          <img src={warningIcon} alt="" />
                          <p>
                            Fai attenzione perché il servizio non può essere
                            modificato dopo che è stato effettuato un pagamento.
                          </p>
                        </DefaultInfo>
                      </div>
                      <div className="col-12 col-xxl-4">
                        <div className="d-flex align-items-center justify-content-end">
                          <AddGuaranteesButton
                            onClick={() => sendServiceAmount()}
                          >
                            Aggiungi
                          </AddGuaranteesButton>
                          {rc_quotation.quotation_services.length !== 0
                          && serviceRef.current.values[0] > 0 ? (
                            <RemoveGuaranteeButton
                              className="ms-2"
                              onClick={() => setServiceAmountToZero()}
                            >
                              Rimuovi
                            </RemoveGuaranteeButton>
                            ) : (
                              ''
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <MarkupSliderContainer>
                          <MarkupPrice>&euro; 60</MarkupPrice>
                          <MarkupSlider>
                            <Range
                              values={
                                service.values < 60
                                  ? initialService.values
                                  : service.values
                              }
                              step={STEP}
                              min={60}
                              max={90}
                              onChange={(values) => setService({ values })}
                              renderTrack={({ props, children }) => (
                                <div
                                  onMouseDown={props.onMouseDown}
                                  onTouchStart={props.onTouchStart}
                                  style={{
                                    ...props.style,
                                    height: '36px',
                                    display: 'flex',
                                    width: '95%',
                                    margin: '0 auto',
                                  }}
                                >
                                  <div
                                    className="range-responsive-slide"
                                    ref={props.ref}
                                    style={{
                                      height: '20px',
                                      width: '100%',
                                      borderRadius: '140px',
                                      alignSelf: 'center',
                                      backgroundColor: '#DFF3EA',
                                    }}
                                  >
                                    {children}
                                  </div>
                                </div>
                              )}
                              renderThumb={({ props }) => (
                                <div
                                  className="range-responsive-circle"
                                  {...props}
                                  style={{
                                    ...props.style,
                                    height: '40px',
                                    width: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: '#00A651',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    border: 'none',
                                    boxShadow: 'none',
                                    outline: 'none',
                                  }}
                                >
                                  <div
                                    className="range-responsive-text"
                                    style={{
                                      position: 'absolute',
                                      top: '-35px',
                                      width: '100px',
                                      color: '#00A551',
                                      textAlign: 'center',
                                      fontFamily: 'Inter',
                                      fontSize: '20px',
                                      fontStyle: 'normal',
                                      fontWeight: '500',
                                      lineHeight: '24px',
                                    }}
                                  >
                                    &euro;
                                    {' '}
                                    {service.values[0].toFixed(2)}
                                  </div>
                                </div>
                              )}
                            />
                          </MarkupSlider>
                          <MarkupPrice>&euro; 90</MarkupPrice>
                        </MarkupSliderContainer>
                      </div>
                    </div>
                  </MarkupContainer>
                )} */}
              </div>
            )}
        </div>
        {[1].includes(rc_quotation.product_id) && shouldShowExtraServiceButton() && (
          <div className="col-12 col-xxl-12 mt-0 mb-2 mt-xxl-0">
            <ServiceComponent
              rc_quotation={rc_quotation}
              getTotal={getTotal}
              insuranceRequest={insuranceRequest}
              collectQuoteData={collectQuoteData}
              risk_quotations={risk_quotations}
            />
          </div>
        )}

        <PaymentFrequencyHeading className="col-12">
          <div>
            <span>Totale da pagare</span>
            <strong>
              {get_amount_to_pay()}
              {' '}
              &euro;
            </strong>
          </div>
          <p>
            Frequenza:
            {' '}
            <b>{rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}</b>
          </p>
        </PaymentFrequencyHeading>

        <div className="col-12 col-lg-6 mt-2 mt-lg-0 pagament-status-step-five">
          <WaitingForPaymentInfo>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h3 className="mb-0">
                Informazioni
                {' '}
                <b>cliente</b>
              </h3>
              <button
                type="button"
                className="btn btn-outline-success btn-sm"
                onClick={goToCustomerScreen}
              >
                Anagrafica Cliente
              </button>
            </div>
            <InfoBoxContainer>
              {quoteData.insurance_request.customer && (
                <>
                  <InfoItem>
                    <h4>
                      {quoteData.insurance_request.customer.gender !== 'G'
                        ? 'Nome e Cognome'
                        : 'Ragione Sociale'}
                      :
                    </h4>
                    <p>
                      {quoteData.insurance_request.customer.gender !== 'G'
                        ? `${quoteData.insurance_request.customer?.name} ${quoteData.insurance_request.customer?.surname}`
                        : quoteData.insurance_request.customer?.business_name}
                    </p>
                  </InfoItem>
                  <InfoItem>
                    <h4>Telefono:</h4>
                    <p>{quoteData.insurance_request.customer.phone}</p>
                  </InfoItem>
                  <InfoItem>
                    <h4>Email:</h4>
                    <p>{quoteData.insurance_request.customer.email}</p>
                  </InfoItem>
                  <InfoItem>
                    <h4>Indirizzo:</h4>
                    <p>
                      {quoteData.insurance_request.customer.address}
                      {' '}
                      {quoteData.insurance_request.customer.house_number
                        !== null
                        && quoteData.insurance_request.customer.house_number}
                      ,
                      {' '}
                      {`${quoteData.insurance_request.customer.city_of_residence?.name} ${insuranceRequest.customer.postal_code}`}
                    </p>
                  </InfoItem>
                </>
              )}
              {quoteData.insurance_request.commercial_company && (
                <InfoItem>
                  <h4>Ragione Sociale :</h4>
                  <p>
                    {
                      quoteData.insurance_request.commercial_company
                        .business_name
                    }
                  </p>
                </InfoItem>
              )}

              <InfoItem>
                <h4>Frequeza Pagamento:</h4>
                <p>
                  {quoteData.quotation.payment_frequency === 1
                    ? 'Annuo'
                    : 'Semestrale'}
                </p>
              </InfoItem>
              {rc_quotation.payment_frequency === 2
                && rc_quotation.amount_paid !== null && (
                  <InfoItem>
                    <h4>Scadenza:</h4>
                    <p>
                      {moment(insuranceRequest.policy_effective_date)
                        .add(1, 'year')
                        .toDate()
                        .toLocaleDateString('it-IT')}
                    </p>
                  </InfoItem>
              )}
              {rc_quotation.payment_frequency === 2
                && rc_quotation.amount_paid === null && (
                  <InfoItem>
                    <h4>Scadenza:</h4>
                    <p>
                      {moment(insuranceRequest.policy_effective_date)
                        .add(6, 'months')
                        .toDate()
                        .toLocaleDateString('it-IT')}
                    </p>
                  </InfoItem>
              )}
              {rc_quotation.payment_frequency === 1 && (
                <InfoItem>
                  <h4>Scadenza:</h4>
                  <p>
                    {moment(insuranceRequest.policy_effective_date)
                      .add(1, 'year')
                      .toDate()
                      .toLocaleDateString('it-IT')}
                  </p>
                </InfoItem>
              )}
            </InfoBoxContainer>
          </WaitingForPaymentInfo>
        </div>
        <div className="col-12 col-lg-6 mt-2 mt-lg-0 order-first order-lg-last pagament-status-step-six">
          <WaitingForPaymentQuoteInfo>
            <QuoteInfoContainer>
              <div>
                <h3 className="ps-3 mb-4 mt-0">
                  Detagli
                  {' '}
                  <b>Pagamento</b>
                </h3>
              </div>
              {/* <QuoteAmountTable className="table-responsive">
                <table className="table font-smaller">
                  <thead>
                    <tr>
                      <th scope="col">Prodotto</th>
                      <th scope="col">Pagato</th>
                      <th scope="col">
                        {' '}
                        {rc_quotation.amount_paid === null
                          ? 'Primo Pagamento'
                          : 'Secondo Pagamento'}
                      </th>
                      <th scope="col">Premio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rc_quotation.product.id === 8 && insuranceRequest.is_offine === 0 ? (
                      rc_quotation !== null
                      && rc_quotation.quotation_data_travel_europeassistance.quotation_data_travel_europeassistance_coverages.map(
                        (coverage, index) => (
                          <React.Fragment key={index}>
                            {coverage.enabled === 0
                              && coverage.group_id === null && (
                                <tr key={index}>
                                  <th>{coverage.title}</th>
                                  <td>
                                    {rc_quotation.amount_paid === null
                                      ? '0.00'
                                      : coverage.coverage_amount_gros
                                      / rc_quotation.payment_frequency}
                                    {' '}
                                    €
                                  </td>
                                  <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    &euro;
                                  </td>
                                  <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    {' '}
                                    &euro;
                                  </td>
                                </tr>
                              )}
                          </React.Fragment>
                        ),
                      )
                    ) : (
                      <tr>
                        <th scope="row">{rc_quotation.risk_information && rc_quotation.risk_information?.product_name ? safeCapitalizeWords(rc_quotation?.risk_information?.product_name) : safeCapitalizeWords(rc_quotation.product.name)}</th>
                        <td>
                          {parseFloat(
                            rc_quotation.amount_paid
                              ? rc_quotation.amount_paid
                              : 0,
                          ).toFixed(2)}
                          &euro;
                        </td>
                        <td>
                          {rc_quotation.product_id === 1006 ? (
                            <>
                              {parseFloat(rc_quotation.amount - 10 - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                            </>
                          ) : (
                            <>
                              {rc_quotation.amount_paid
                                ? (
                                  parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                                  - parseFloat(rc_quotation.amount_paid).toFixed(2)
                                ).toFixed(2)
                                : parseFloat(
                                  (rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                                  / rc_quotation.payment_frequency,
                                ).toFixed(2)}
                            </>
                          )}
                          &euro;
                        </td>
                        <td>
                          {rc_quotation.product_id === 1006 ? parseFloat(rc_quotation.amount - 10 - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2) : parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                          &euro;
                        </td>
                      </tr>
                    )}
                    {risk_quotations
                      && risk_quotations.map((riskQuote, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {riskQuote.risk_information && riskQuote.product_id !== 15
                              ? safeCapitalizeWords(riskQuote.risk_information.product_name)
                              : quoteTypes.find(
                                (q) => q.id === riskQuote.quote_type,
                              ) !== undefined
                                ? safeCapitalizeWords(quoteTypes.find(
                                  (q) => q.id === riskQuote.quote_type,
                                )?.name)
                                : ''}
                          </th>
                          <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {parseFloat(
                                  riskQuote.amount_paid ? riskQuote.amount_paid : 0,
                                ).toFixed(2)}
                                &euro;
                              </>
                            )}
                          </td>
                          <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {riskQuote.amount_paid
                                  ? (
                                    parseFloat(riskQuote.amount).toFixed(2)
                                    - parseFloat(riskQuote.amount_paid).toFixed(2)
                                  ).toFixed(2)
                                  : parseFloat(
                                    riskQuote.amount / riskQuote.payment_frequency,
                                  ).toFixed(2)}
                                &euro;
                              </>
                            )}
                          </td>
                          <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {parseFloat(riskQuote.amount).toFixed(2)}
                                &euro;
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    {rc_quotation !== null
                      && rc_quotation.company_id === 2
                      && rc_quotation.guarantees.map((guarantee, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {
                              primaQuoteTypes.find(
                                (type) => type.id === guarantee.guarantees_slug,
                              )?.name
                            }
                          </th>
                          <td>
                            {' '}
                            {rc_quotation.amount_paid === null
                              ? '0'
                              : guarantee.amount
                              / rc_quotation.payment_frequency}
                            {' '}
                            €
                          </td>
                          <td>
                            {' '}
                            {parseFloat(
                              guarantee.amount / rc_quotation.payment_frequency,
                            ).toFixed(2)}
                            {' '}
                            €
                          </td>
                          <td>
                            {' '}
                            {parseFloat(guarantee.amount).toFixed(2)}
                            {' '}
                            €
                          </td>
                        </tr>
                      ))}
                    {rc_quotation !== null
                      && rc_quotation.product_id === 8
                      && rc_quotation.guarantees.map((guarantee, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {guarantee.guarantees_description}
                          </th>
                          <td>
                            {' '}
                            {rc_quotation.amount_paid === null
                              ? '0.00'
                              : guarantee.amount
                              / rc_quotation.payment_frequency}
                            {' '}
                            €
                          </td>
                          <td>
                            {' '}
                            {parseFloat(
                              guarantee.amount / rc_quotation.payment_frequency,
                            ).toFixed(2)}
                            {' '}
                            €
                          </td>
                          <td>
                            {' '}
                            {parseFloat(guarantee.amount).toFixed(2)}
                            {' '}
                            €
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <th scope="row">Spese di Emissione</th>
                      <td>
                        {rc_quotation.amount_paid === null
                          ? '0.00'
                          : (rc_quotation.product_id === 1006
                            ? parseFloat((10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2)
                            : parseFloat((parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2))}
                        &euro;
                      </td>
                      <td>
                        {rc_quotation.amount_paid !== null
                          ? '0.00'
                          : (rc_quotation.product_id === 1006
                            ? parseFloat((10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2)
                            : parseFloat((parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2))}
                        &euro;
                      </td>
                      <td>
                        {rc_quotation.product_id === 1006 ? parseFloat(10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2) : parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                        &euro;
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Brokeraggio</th>
                      <td>
                        {rc_quotation.amount_paid === null
                          ? '0.00'
                          : getBrokeragePerPayment(rc_quotation).toFixed(2)}
                        &euro;
                      </td>
                      <td>
                        {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation)
                          ? '0.00'
                          : getBrokeragePerPayment(rc_quotation).toFixed(2)}
                        &euro;
                      </td>
                      <td>
                        {parseFloat(rc_quotation.brokerage_amount).toFixed(2)}
                        &euro;
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>

                    {insuranceRequest.insurance_request_extra_services?.length > 0 && (
                      <>
                        {insuranceRequest.insurance_request_extra_services.map((service, index) => (
                          <tr key={index}>
                            <th scope="row" colSpan="2">
                              {service.service_name}
                            </th>
                            <td>
                              {' '}
                              {calculateExtraServicePrice(rc_quotation, service)}
                              €
                            </td>
                            <td className="fw-bold">
                              {service.total_price
                                ? parseFloat(service.total_price).toFixed(2)
                                : '0.00'}
                              &euro;
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    <tr>
                      <th scope="row" colSpan="3">
                        Total
                      </th>
                      <td className="fw-bold">
                        {getTotalAmount()}
                        &euro;
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </QuoteAmountTable> */}
              <QuoteAmountTable className="table-responsive">
                <table className="table font-smaller">
                  <thead>
                    <tr>
                      <th scope="col">Prodotto</th>
                      {/* <th scope="col">Frequenza Pagamento</th> */}
                      {/* <th scope="col">
                        {' '}
                        {rc_quotation.amount_paid === null
                          ? 'Primo Pagamento'
                          : 'Secondo Pagamento'}
                      </th> */}
                      <th scope="col">Premio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rc_quotation.product_id === 8 && insuranceRequest.is_offline === 0 ? (
                      rc_quotation !== null
                      && rc_quotation.quotation_data_travel_europeassistance.quotation_data_travel_europeassistance_coverages.map(
                        (coverage, index) => (
                          <React.Fragment key={index}>
                            {rc_quotation.quotation_data_travel_europeassistance.product_code === 'EA0177' && (
                              coverage.enabled === 0
                              && coverage.group_id === null && (
                                <tr key={index}>
                                  <th>{coverage.title}</th>
                                  {/* <td>
                                    {rc_quotation.amount_paid === null
                                      ? '0.00'
                                      : coverage.coverage_amount_gros
                                      / rc_quotation.payment_frequency}
                                    {' '}
                                    €
                                    {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}
                                  </td> */}
                                  <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    &euro;
                                  </td>
                                  {/* <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    {' '}
                                    &euro;
                                  </td> */}
                                </tr>
                              )
                            )}
                            {rc_quotation.quotation_data_travel_europeassistance.product_code === 'EA0190' && (
                              coverage.enabled === 0
                              && coverage.group_id === '1' && (
                                <tr key={index}>
                                  <th>{coverage.title}</th>
                                  {/* <td>
                                    {rc_quotation.amount_paid === null
                                      ? '0.00'
                                      : coverage.coverage_amount_gros
                                      / rc_quotation.payment_frequency}
                                    {' '}
                                    €
                                    {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}
                                  </td> */}
                                  <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    &euro;
                                  </td>
                                  {/* <td>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    {' '}
                                    &euro;
                                  </td> */}
                                </tr>
                              )
                            )}

                          </React.Fragment>
                        ),
                      )
                    ) : (
                      <tr>
                        <th scope="row">{rc_quotation.risk_information && rc_quotation.risk_information?.product_name ? safeCapitalizeWords(rc_quotation?.risk_information?.product_name) : safeCapitalizeWords(rc_quotation.product.name)}</th>
                        {/* <td>
                          {parseFloat(
                            rc_quotation.amount_paid
                              ? rc_quotation.amount_paid
                              : 0,
                          ).toFixed(2)}
                          &euro;
                          {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                        </td> */}
                        <td>
                          {rc_quotation.product_id === 1006 ? (
                            <>
                              {parseFloat(rc_quotation.amount - 10 - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                            </>
                          ) : (
                            <>
                              {rc_quotation.amount_paid
                                ? (
                                  parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                                  - parseFloat(rc_quotation.amount_paid).toFixed(2)
                                ).toFixed(2)
                                : parseFloat(
                                  (rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                                  / rc_quotation.payment_frequency,
                                ).toFixed(2)}
                            </>
                          )}
                          &euro;
                        </td>
                        {/* <td>
                          {rc_quotation.product_id === 1006 ? parseFloat(rc_quotation.amount - 10 - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2) : parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                          &euro;
                        </td> */}
                      </tr>
                    )}
                    {risk_quotations
                      && risk_quotations.map((riskQuote, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {riskQuote.risk_information && riskQuote.product_id !== 15
                              ? safeCapitalizeWords(riskQuote.risk_information.product_name)
                              : quoteTypes.find(
                                (q) => q.id === riskQuote.quote_type,
                              ) !== undefined
                                ? safeCapitalizeWords(quoteTypes.find(
                                  (q) => q.id === riskQuote.quote_type,
                                )?.name)
                                : ''}
                          </th>
                          {/* <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {parseFloat(
                                  riskQuote.amount_paid ? riskQuote.amount_paid : 0,
                                ).toFixed(2)}
                                &euro;
                              </>
                            )}
                            {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                          </td> */}
                          <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {riskQuote.amount_paid
                                  ? (
                                    parseFloat(riskQuote.amount).toFixed(2)
                                    - parseFloat(riskQuote.amount_paid).toFixed(2)
                                  ).toFixed(2)
                                  : parseFloat(
                                    riskQuote.amount / riskQuote.payment_frequency,
                                  ).toFixed(2)}
                                &euro;
                              </>
                            )}
                          </td>
                          {/* <td>
                            {rc_quotation.product_id !== 1006 && (
                              <>
                                {parseFloat(riskQuote.amount).toFixed(2)}
                                &euro;
                              </>
                            )}
                          </td> */}
                        </tr>
                      ))}
                    {rc_quotation !== null
                      && rc_quotation.company_id === 2
                      && rc_quotation.guarantees.map((guarantee, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {
                              primaQuoteTypes.find(
                                (type) => type.id === guarantee.guarantees_slug,
                              )?.name
                            }
                          </th>
                          {/* <td>
                            {' '}
                            {rc_quotation.amount_paid === null
                              ? '0'
                              : guarantee.amount
                              / rc_quotation.payment_frequency}
                            {' '}
                            €
                            {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                          </td> */}
                          <td>
                            {' '}
                            {parseFloat(
                              guarantee.amount / rc_quotation.payment_frequency,
                            ).toFixed(2)}
                            {' '}
                            €
                          </td>
                          {/* <td>
                            {' '}
                            {parseFloat(guarantee.amount).toFixed(2)}
                            {' '}
                            €
                          </td> */}
                        </tr>
                      ))}
                    {rc_quotation !== null
                      && rc_quotation.product_id === 8
                      && rc_quotation.guarantees.map((guarantee, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {guarantee.guarantees_description}
                          </th>
                          {/* <td>
                            {' '}
                            {rc_quotation.amount_paid === null
                              ? '0.00'
                              : guarantee.amount
                              / rc_quotation.payment_frequency}
                            {' '}
                            €
                            {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                          </td> */}
                          <td>
                            {' '}
                            {parseFloat(
                              guarantee.amount / rc_quotation.payment_frequency,
                            ).toFixed(2)}
                            {' '}
                            €
                          </td>
                          {/* <td>
                            {' '}
                            {parseFloat(guarantee.amount).toFixed(2)}
                            {' '}
                            €
                          </td> */}
                        </tr>
                      ))}
                    <tr>
                      <th scope="row">Spese di Emissione</th>
                      {/* <td>
                        {rc_quotation.amount_paid === null
                          ? '0.00'
                          : (rc_quotation.product_id === 1006
                            ? parseFloat((10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2)
                            : parseFloat((parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2))}
                        &euro;
                        {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                      </td> */}
                      <td>
                        {(rc_quotation.product_id === 1006
                          ? parseFloat((10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2)
                          : parseFloat((parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2))}
                        &euro;
                      </td>
                      {/* <td>
                        {rc_quotation.product_id === 1006 ? parseFloat(10 + parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2) : parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                        &euro;
                      </td> */}
                    </tr>
                    <tr>
                      <th scope="row">Brokeraggio</th>
                      {/* <td>
                        {rc_quotation.amount_paid === null
                          ? '0.00'
                          : getBrokeragePerPayment(rc_quotation).toFixed(2)}
                        &euro;
                        {rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}

                      </td> */}
                      <td>
                        {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation)
                          ? '0.00'
                          : getBrokeragePerPayment(rc_quotation).toFixed(2)}
                        &euro;
                      </td>
                      {/* <td>
                        {parseFloat(rc_quotation.brokerage_amount).toFixed(2)}
                        &euro;
                      </td> */}
                    </tr>
                  </tbody>
                  <tfoot>
                    {/* {!hideBrokerageAndService
                      && rc_quotation.amount_paid === null && (
                        <>
                          <tr>
                            <th scope="row" colSpan="3">
                              Servizio
                            </th>
                            <td className="fw-bold">
                              {(rc_quotation.quotation_services.length > 0
                                ? rc_quotation.quotation_services[0]
                                  .amount_gross
                                : 0
                              ).toFixed(2)}
                              &euro;
                            </td>
                          </tr>
                        </>
                      )} */}
                    {insuranceRequest.insurance_request_extra_services?.length > 0 && (
                      <>
                        {insuranceRequest.insurance_request_extra_services?.map((service, index) => (
                          <tr key={index}>
                            <th scope="row">
                              {service.service_name}
                            </th>
                            <td>
                              {' '}
                              {calculateExtraServicePrice(rc_quotation, service)}
                              €
                            </td>
                            {/* <td className="fw-bold">
                              {service.total_price
                                ? parseFloat(service.total_price).toFixed(2)
                                : '0.00'}
                              &euro;
                            </td> */}
                          </tr>
                        ))}
                      </>
                    )}
                    <tr>
                      <th scope="row" colSpan="1">
                        Total
                      </th>
                      <td className="fw-bold">
                        {getTotalAmount()}
                        &euro;
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </QuoteAmountTable>
            </QuoteInfoContainer>
          </WaitingForPaymentQuoteInfo>
        </div>
      </div>

      {rc_quotation.with_compensation === 0 && (
        <>
          {quoteData.quotation_payments.length !== 0 && (
            <div className="row mt-3 ">
              <div className="col-12 col-xxl-12">
                <PayByCardContainer>
                  {rc_quotation.with_compensation === 0 && (
                    <>
                      {quoteData.quotation_payments.length !== 0 && (
                        <div>
                          <h3>Stato del pagamento</h3>
                          {quoteData.quotation_payments.map((payment) => (
                            <div className="payment-record" key={payment.id}>
                              <div className="field-row">
                                <div className="field-name">
                                  <b>Carta</b>
                                </div>
                                <div className="field-value">
                                  ************
                                  {payment.last_four}
                                </div>
                              </div>
                              <div className="field-row">
                                <div className="field-name">
                                  <b>Stato</b>
                                </div>
                                <div className="field-value">
                                  <span
                                    className={
                                      payment.status_name === 'In attesa'
                                        ? 'badge bg-warning text-dark'
                                        : payment.status_name === 'Rifiutato'
                                          ? 'badge bg-danger'
                                          : 'badge bg-success'
                                    }
                                  >
                                    {payment.status_name}
                                  </span>
                                </div>
                              </div>
                              <div className="field-row">
                                <div className="field-name">
                                  <b>Pagato</b>
                                </div>
                                <div className="field-value">
                                  {payment.amount.toLocaleString()}
                                  {' '}
                                  &euro;
                                </div>
                              </div>
                              <div className="field-row">
                                <div className="field-name">
                                  <b>Ora</b>
                                </div>
                                <div className="field-value">
                                  {moment(payment.created_at).format(
                                    'DD.MM.YYYY hh:mm',
                                  )}
                                </div>
                              </div>
                              {/* {payment.status === 1 &&
                         payment.user_redirect !== null && (
                           <div className="field-row">
                             <a target="_blank" href={payment.user_redirect}>
                               <div className="btn btn-success">
                                 Autorizza il pagamento
                               </div>
                             </a>
                           </div>
                         )} */}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </PayByCardContainer>
              </div>
            </div>
          )}
        </>
      )}

      <div className="row mt-3">
        <PaymentMethodSection className="col-12">
          <h3>Come vuoi pagare?</h3>
          <PaymentMethodOptions role="tablist">
            <PaymentMethodOption
              type="button"
              role="tab"
              aria-selected={paymentMethod === 'card'}
              $active={paymentMethod === 'card'}
              onClick={() => selectPaymentMethod('card')}
            >
              <FontAwesomeIcon icon={faCreditCard} />
              <span>
                <b>Carta</b>
                <small>Pagamento immediato</small>
              </span>
            </PaymentMethodOption>
            <PaymentMethodOption
              type="button"
              role="tab"
              aria-selected={paymentMethod === 'bank'}
              $active={paymentMethod === 'bank'}
              onClick={() => selectPaymentMethod('bank')}
            >
              <FontAwesomeIcon icon={faLandmark} />
              <span>
                <b>Bonifico</b>
                <small>Carica la prova del pagamento</small>
              </span>
            </PaymentMethodOption>
            {canCompensate && (
              <PaymentMethodOption
                type="button"
                role="tab"
                aria-selected={paymentMethod === 'compensation'}
                $active={paymentMethod === 'compensation'}
                onClick={() => selectPaymentMethod('compensation')}
              >
                <FontAwesomeIcon icon={faHandHoldingDollar} />
                <span>
                  <b>Incasso</b>
                  <small>Registra un incasso</small>
                </span>
              </PaymentMethodOption>
            )}
          </PaymentMethodOptions>
          <div ref={paymentPanelRef} style={{ scrollMarginTop: '90px', scrollMarginBottom: '16px' }}>
            {paymentMethod === 'card' && (
              <div className="pagament-status-step-seven">
                <PayByCardContainer>
                  <h3 className="pay-title">
                    Paga con
                    {' '}
                    <b>carta</b>
                    {' '}
                    (
                    {get_amount_to_pay()}
                    {' '}
                    &euro;)
                  </h3>
                  <form onSubmit={handleSubmit(submitData)}>
                    <FormInputGroup $isInvalid={errors.card_number?.message !== undefined}>
                      <label htmlFor="">Carta di credito o di debito</label>
                      <input
                        type="text"
                        {...register('card_number')}
                        placeholder="Inserisci il numero della carta"
                      />
                      <ErrorMessage>{errors.card_number?.message}</ErrorMessage>
                    </FormInputGroup>
                    <FormInputGroupContainer>
                      <FormInputGroup $isInvalid={errors.card_expiry?.message !== undefined}>
                        <label htmlFor="">Data di scadenza</label>
                        <Controller
                          name="card_expiry"
                          control={control}
                          render={({ field }) => (
                            <input
                              type="text"
                              {...field}
                              placeholder="MM/AA"
                              maxLength="5"
                              onChange={handleInputChange}
                            />
                          )}
                        />
                        <ErrorMessage>{errors.card_expiry?.message}</ErrorMessage>
                      </FormInputGroup>
                      <FormInputGroup $isInvalid={errors.card_cvv?.message !== undefined}>
                        <label htmlFor="">Codice di sicurezza (CVV)</label>
                        <input
                          type="text"
                          {...register('card_cvv')}
                          placeholder="CVV"
                        />
                        <ErrorMessage>{errors.card_cvv?.message}</ErrorMessage>
                      </FormInputGroup>
                    </FormInputGroupContainer>
                    <WarningInfo>
                      <img src={warningIcon} alt="" />
                      <p>
                        Se si fa clic su Invia verrà visualizzata una modalità di
                        conferma, dopo la conferma attendere un paio di minuti per
                        l'elaborazione. Grazie!
                      </p>
                    </WarningInfo>
                    <PayNowButton>Procedi con il pagamento</PayNowButton>
                  </form>
                </PayByCardContainer>
              </div>
            )}
            {paymentMethod === 'bank' && (
              <div className="pagament-status-step-eight">
                <PayByBankTransfer>
                  <h3 className="pay-title">
                    Paga con
                    {' '}
                    <b>bonifico</b>
                    {' '}
                    (
                    {get_amount_to_pay()}
                    {' '}
                    &euro;)
                  </h3>
                  {bonificoPayments.map((payment, index) => {
                    const pp = payment.rcProof;

                    return (
                      <PaymentProofStyled key={pp.id} $valid={payment.valid}>
                        <h6>
                          Pagamento
                          {' '}
                          {index + 1}
                          {': '}
                          {payment.valid === 1 && (
                            <>
                              {payment.amount.toFixed(2)}
                              {' '}
                              &euro;
                            </>
                          )}
                          {payment.valid === null && (
                            <>
                              {' '}
                              : In verifica (
                              {payment.amount.toFixed(2)}
                              {' '}
                              &euro;)
                            </>
                          )}
                          {payment.valid === 0 && <> : Non valido</>}
                        </h6>

                        {(totalPaymentsRequired === 1
                          || (totalPaymentsRequired === 2
                            && paymentsMadeWithBonifico - paymentMadeCount + 1 === index)
                          || (totalPaymentsRequired === 2 && paymentMadeCount === 0)) && (
                            <>
                              {payment.valid === 0 && (
                                <div className="alert alert-danger">
                                  La prova del pagamento non e valida
                                </div>
                              )}
                              {payment.valid === 1 && (
                                <div className="alert alert-success">
                                  La prova del pagamento e valida
                                </div>
                              )}
                              {pp.payment_proof_file !== null && payment.valid === null && (
                                <div className="alert alert-warning">
                                  Stiamo verificando la prova del pagemento
                                </div>
                              )}
                              {/* An <embed> stretches an image to its frame, so images get a plain <img>. */}
                              {typeof pp.file_type === 'string' && pp.file_type.startsWith('image/') ? (
                                <div className="proof-image">
                                  <img
                                    alt="Prova del pagamento"
                                    src={`data:${pp.file_type};base64,${pp.payment_proof_file}`}
                                  />
                                </div>
                              ) : (
                                <embed
                                  type={pp.file_type}
                                  style={{
                                    marginTop: '10px',
                                    width: '100%',
                                    minHeight: '250px',
                                  }}
                                  src={`data:${pp.file_type};base64,${pp.payment_proof_file}`}
                                />
                              )}
                            </>
                        )}
                      </PaymentProofStyled>
                    );
                  })}

                  {/* {rc_quotation.payment_proofs.map((pp, index) => (
                  <PaymentProofStyled key={pp.id}>
                    <h6>
                      Pagamento
                      {' '}
                      {index + 1}
                      {' '}
                      : Pagato:
                      {' '}
                      {getTotalAmountPaidBonifico()}
                      {' '}
                      &euro;
                    </h6>

                    {(totalPaymentsRequired === 1
                      || (totalPaymentsRequired === 2
                        && paymentsMadeWithBonifico - paymentMadeCount + 1
                        === index)
                      || (totalPaymentsRequired === 2 && paymentMadeCount === 0)) && (
                        <>
                          {pp.payment_proof_valid === 0 && (
                            <div className="alert alert-danger">
                              La prova del pagamento non e valida
                            </div>
                          )}
                          {pp.payment_proof_valid === 1 && (
                            <div className="alert alert-success">
                              La prova del pagamento e valida
                            </div>
                          )}

                          {pp.payment_proof_file !== null
                            && pp.payment_proof_valid === null && (
                              <div className="alert alert-warning">
                                Stiamo verificando la prova del pagemento
                              </div>
                            )}
                          <embed
                            type={pp.file_type}
                            style={{
                              marginTop: '10px',
                              width: '100%',
                              minHeight: '250px',
                            }}
                            src={`data:${pp.file_type};base64,${pp.payment_proof_file}`}
                          />
                        </>
                      )}
                  </PaymentProofStyled>
                ))} */}
                  {rc_quotation.payment_proofs.find(
                    (pp) => pp.payment_proof_valid === null,
                  ) === undefined && (
                  <>
                    <BankTransferInfo>
                      <BankTransferInfoItem>
                        Iban:
                        {' '}
                        <span>IT60B0326803210052864099270</span>
                      </BankTransferInfoItem>
                      <BankTransferInfoItem>
                        Titolare:
                        {' '}
                        <span>Greenia srl</span>
                      </BankTransferInfoItem>
                      <BankTransferInfoItem>
                        Causale:
                        {' '}
                        <span>
                          Pagamento polizza
                          {' '}
                          {quoteData.insurance_request.customer
                                && (quoteData.insurance_request.customer.gender !== 'G'
                                  ? `${quoteData.insurance_request.customer?.name} ${quoteData.insurance_request.customer.surname}`
                                  : quoteData.insurance_request.customer.business_name)}
                          {quoteData.insurance_request.commercial_company
                                && quoteData.insurance_request.commercial_company
                                  .business_name}
                        </span>
                      </BankTransferInfoItem>
                    </BankTransferInfo>
                    <UploaderBonifico
                      v2
                      note="CARICA PROVA DEL PAGAMENTO"
                      onFileUpload={(file) => uploadPaymentProf(file)}
                    />
                    {/* {user.compensations === 1 && (
              <div className="row justify-content-center footer-button">
                <button
                  className="btn btn-outline-success"
                  onClick={() => compensationConfirmAlertHandle()}
                >
                  Paga con compensazione
                </button>
              </div>
              )} */}

                    {/* {user.compensations === 1 && (
                <div className="row justify-content-center footer-button">
                  {!showSelect ? (
                    <button
                      className="btn btn-outline-success"
                      onClick={() => setShowSelect(true)}
                    >
                      Incasso
                    </button>
                  ) : (
                    <CompensationForm onSubmit={handleSubmitCompensation(compensationConfirmAlertHandle)}>
                      <FormInputSelect
                        label="Indica Metodo di Incasso"
                        registration={registerCompensation('entry_type')}
                        error={compensationErrors.entry_type?.message}
                        valid={isValid('entry_type')}
                        placeholder="-Seleziona-"
                        options={compensationPaymentMethod}
                      />
                      <PayNowButton type="submit">
                        Invia
                      </PayNowButton>
                    </CompensationForm>
                  )}
                </div>
                )} */}
                  </>
                  )}
                </PayByBankTransfer>
              </div>
            )}
            {paymentMethod === 'compensation' && canCompensate && (
              <div>
                <PayByBankTransfer>
                  <h3 className="pay-title">
                    Registra
                    {' '}
                    <b>incasso</b>
                    {' '}
                    (
                    {get_amount_to_pay()}
                    {' '}
                    &euro;)
                  </h3>
                  <CompensationForm onSubmit={handleSubmitCompensation(compensationConfirmAlertHandle)}>
                    <FormInputSelect
                      label="Indica Metodo di Incasso"
                      registration={registerCompensation('entry_type')}
                      error={compensationErrors.entry_type?.message}
                      valid={isValid('entry_type')}
                      placeholder="-Seleziona-"
                      options={compensationPaymentMethod}
                    />
                    <PayNowButton type="submit">
                      Invia
                    </PayNowButton>
                  </CompensationForm>
                </PayByBankTransfer>
              </div>
            )}
          </div>
        </PaymentMethodSection>
      </div>
      {paymentAuthorizationUrl && (
        <div className="x-modal" id="fastquote-modal">
          <div
            className="x-modal-cover"
            onClick={() => setPaymentAuthorizationUrl(null)}
          />
          <div className="general-modal-content">
            <span
              className="general-modal-close"
              title="Quidi"
              onClick={() => setPaymentAuthorizationUrl(null)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" />
              </svg>
            </span>
            <div className="modal-header">
              <h5 className="modal-title">Autorizza il pagamento</h5>
            </div>
            <div className="x-modal-body">
              <iframe
                title="Authorization frame"
                style={{ width: '100%', height: '70vh' }}
                src={paymentAuthorizationUrl}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary m-2"
                onClick={() => setPaymentAuthorizationUrl(null)}
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default WaitingForPaymentStatusV2;
